<template>
    <v-form
        ref="form"
        v-model="valid"
        class="form"
        lazy-validation>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="4"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.firstName"
                        :rules="[requiredRule]"
                        label="First name*" />
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                    class="py-0">
                    <v-text-field
                        v-model="formData.lastName"
                        :rules="[requiredRule]"
                        label="Last name*" />
                </v-col>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.email"
                        :rules="emailRules"
                        label="Email address*" />
                </v-col>
                <v-col
                    cols="6"
                    md="4"
                    offset-md="2"
                    class="py-0">
                    <v-text-field
                        v-model="formData.phoneNumber"
                        v-mask="'(###) ###-####'"
                        label="Phone number*"
                        :rules="requiredRule" />
                </v-col>
                <v-col
                    cols="6"
                    md="4">
                    <div class="password-highlighting">
                        <span>Used as password</span> <v-icon class="ml-1">
                            mdi-lock-outline
                        </v-icon>
                    </div>
                </v-col>
            </v-row>

            <v-row
                justify="center"
                class="mt-5">
                <v-col cols="12">
                    <v-btn
                        color="primary"
                        tile
                        @click="onSubmit">
                        {{ submitLabel }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import { validators } from '@/utils/validators';
import { mask } from 'vue-the-mask';

export default {
    name: 'AppEmailForm',

    directives: {
        mask,
    },

    props: {
        submitLabel: {
            type: String,
            default: 'Send',
        },
    },

    data() {
        return {
            valid: true,
            emailRules: [(v) => validators.required(v, 'Email'), (v) => validators.email(v)],
            requiredRule: (v) => validators.required(v),
            formData: {
                email: (this.$route.query['email'] && this.$route.query['email'].replace(' ', '+')) || null,
                firstName: '',
                lastName: '',
                phoneNumber: '',
            },
        };
    },

    methods: {
        onSubmit() {
            this.$refs.form.validate();

            if (this.valid) {
                this.$emit('submit', this.formData);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.password-highlighting {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #4caf50;
    i {
        color: #4caf50;
    }
}
</style>